import g from '#core/global';
import load from '#core/load';
import util from '#core/util';


const state = window.teal_state = window.teal_state || {};
state.sticky = state.sticky || {};

const id_attr = 'data-sticky-id';
const threshold_attr = 'data-sticky-threshold';
const root_$ = ':root';

const element_tops = {};

let has_sticky = false;
let $stickies = null;
let $root = null;


const module = {
	stuck_c: 'sticky-stuck',
	
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('sticky')) return false;
		
		load.content(() => {
			has_sticky = assign_elements();
			if (!has_sticky) return false;
			
			assign_scroll_events();
			check_all();
		});
		load.all(() => {
			has_sticky = assign_elements();
			if (!has_sticky) return false;
			
			check_all();
		});
	},
	
};

export default module;
module.init(); // Do not enable this, it's problematic


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_sticky) return true;
	
	// TODO: do not store objects on load, account for dynamic content
	$stickies = document.querySelectorAll(`[${id_attr}]`);
	if (!$stickies) return false;
	
	$root = document.querySelector(root_$);
	
	return true;
}


/**
 * Assign scroll events
 */
function assign_scroll_events() {
	const scroll_callbacks = [
		check_all,
	];
	scroll_callbacks.forEach(callback => callback());
	
	window.addEventListener(g.scroll_e, util.throttle(() => {
		scroll_callbacks.forEach(callback => callback());
	}, 200, {leading: false, trailing: true}));
}


/**
 * Get top position of element
 * @param {element} $element
 * @return {int|boolean}
 */
function get_top($element) {
	const bounds = $element.getBoundingClientRect();
	if (!bounds.width) return false;
	
	return Math.floor(bounds.top);
}


/**
 * Check all elements
 */
function check_all() {
	$stickies.forEach($sticky => {
		check($sticky);
	});
}


/**
 * Check if element is sticky by comparing position to previous position
 * @param {element} $element
 */
function check($element) {
	const top = get_top($element);
	const parent_top = get_top($element.parentNode);
	if (top === false || parent_top === false) return false;
	
	// Method 1: compare to previous position
	// This method is problematic because it requires scrolling, so it can't be
	// evaluated on page load. It also can't determine if the element is at the
	// bottom of its container.
	const use_previous_position = false;
	if (use_previous_position) {
		const id = $element.getAttribute(id_attr);
		const threshold = parseInt($element.getAttribute(threshold_attr));
		if (!id || isNaN(threshold)) return false;
		
		if (element_tops[id] === undefined) {
			element_tops[id] = top;
			return true;
		}
		
		const is_sticky = (
			top === element_tops[id]
			&& top < threshold
		);
		$element.classList.toggle(module.stuck_c, is_sticky);
		element_tops[id] = top;
	}
	
	// Method 2: compare to parent position
	// This method is more reliable and works for keeping an element sticky when
	// it reaches the bottom of its container, but it's unsophisticated. This
	// will only work in certain situations.
	else {
		const is_sticky = (parent_top < top);
		$element.classList.toggle(module.stuck_c, is_sticky);
	}
}


/**
 * Check if element is sticky
 * @deprecated I just can't figure this out
 * @param {element} $element
 */
function global_check_sticky($element) {
	const sticky_observer = new IntersectionObserver(
		([entry]) => {
			const is_sticky = entry.intersectionRatio < 1;
			entry.target.classList.toggle(module.stuck_c, is_sticky);
		}, {
			rootMargin: '-200px 0px 100% 0px',
			threshold: [0],
		}
	);
	sticky_observer.observe($element);
}
